import React from 'react'
import { Trans } from '@lingui/react/macro'
import { usePaginationFragment, graphql } from 'react-relay'

import { YStack, XStack, Separator } from 'tamagui'
import { Strong } from '@newComponents/Text'
import { AutoLoadMore } from '@newComponents/AutoLoadMore'
import { PresentationCard } from '@newComponents/Presentation/PresentationCard'

import { UserPresentationsScreenOtherPresentationsSection_user$key } from './__generated__/UserPresentationsScreenOtherPresentationsSection_user.graphql'

export const UserPresentationsScreenOtherPresentationsSection = ({
  user,
}: {
  user: UserPresentationsScreenOtherPresentationsSection_user$key
}) => {
  const { data, hasNext, loadNext } = usePaginationFragment(
    graphql`
      fragment UserPresentationsScreenOtherPresentationsSection_user on User
      @refetchable(
        queryName: "UserPresentationsScreenOtherPresentationsSectionPaginationQuery"
      )
      @argumentDefinitions(
        count: { type: "Int", defaultValue: 3 }
        cursor: { type: "Cursor" }
      ) {
        otherPresentations: presentations(
          first: $count
          after: $cursor
          timeSelection: OTHER
          orderBy: [CREATED_AT_DESC, ID_ASC]
        )
          @connection(
            key: "UserPresentationsScreenOtherPresentationsSection_user_otherPresentations"
          ) {
          edges {
            node {
              ...PresentationCardNew_presentation
            }

            cursor
          }
        }
      }
    `,
    user
  )

  if (data.otherPresentations.edges.length === 0) {
    return null
  }

  return (
    <YStack gap='$4'>
      <XStack gap='$4' alignItems='center'>
        <Strong color='$color'><Trans>Other Presentations</Trans></Strong>
        <Separator borderColor='$borderColor' />
      </XStack>

      {data.otherPresentations.edges.map((edge) => {
        return (
          <PresentationCard
            key={edge.cursor}
            presentation={edge.node}
            numberOfLines={8}
          />
        )
      })}

      <AutoLoadMore hasNext={hasNext} loadNext={loadNext} count={3} />
    </YStack>
  )
}
